import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";
import Radio from "~/common/components/Radio";
import { AppContext } from "../../../RoundRegContext";
import { useTranslation } from "react-i18next";

const InquiryText = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(AppContext);

	const handleChangeTitle = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	const handleChangeContent = (e) => {
		setListByTarget({ ...card, color: e.target.value });
	};

	return (
		<div className="c__form horiz">
			<div className="f__group export-label ">
				<div className="f__control  ">
					<input
						name="inquiryText"
						className="c__input f__item"
						placeholder={t(
							"pages.round.RoundReg.Inquiry.content.cardType.InquiryText.placeholder"
						)}
						type="text"
						value={card.title}
						onChange={handleChangeTitle}
					/>
				</div>
			</div>
			<div className="f__group export-input ">
				<div className="f__control  ">
					<div className="f__item c__radio-wrap">
						<label className="c__radio">
							<input
								type="radio"
								value="red"
								checked={card.color === "red"}
								onChange={handleChangeContent}
							/>
							<span className="checkmark" />
							<span className="radio-label">RED</span>
						</label>
						<label className="c__radio">
							<input
								type="radio"
								value="blue"
								checked={card.color === "blue"}
								onChange={handleChangeContent}
							/>
							<span className="checkmark" />
							<span className="radio-label">BLUE</span>
						</label>
						<label className="c__radio">
							<input
								type="radio"
								value="green"
								checked={card.color === "green"}
								onChange={handleChangeContent}
							/>
							<span className="checkmark" />
							<span className="radio-label">GREEN</span>
						</label>
						<label className="c__radio">
							<input
								type="radio"
								value="yellow"
								checked={card.color === "yellow"}
								onChange={handleChangeContent}
							/>
							<span className="checkmark" />
							<span className="radio-label">YELLOW</span>
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InquiryText;
